(ns motorsaif.shared.message-subs
  (:require
   [re-frame.core :as rf :refer [reg-sub]]
   [motorsaif.request-utils :as request-utils]
   [reagent.ratom :refer [reaction]]))

(defn last-touch-access [touches topic]
  (:touched/last-access (first (filter #(= (-> % :touched/topic) topic)
                                       (vals touches)))))

(defn unread-msgs-pred [{:keys [thread last-touch]}]
  (filter #(> (-> %
                  :message
                  :date-time/created) last-touch) (:messages thread)))

(reg-sub :unread-requester-messages
  (fn [[_query-v thread-id]]
    (let [[request-id from-id] thread-id]
      [(rf/subscribe [:requester-thread request-id from-id])
       (rf/subscribe [:threads])
       (rf/subscribe [:touches])]))
  (fn [[thread-meta threads touches] _]
    (let [{:keys [thread-id]} thread-meta
          thread (get threads thread-id)
          last-touch (last-touch-access touches thread-id)]
      (unread-msgs-pred {:last-touch last-touch
                         :thread thread}))))

(reg-sub :responder-thread
  (fn [db [_ id]]
    (get (:responder-threads db) id)))

(reg-sub :responder-threads
  (fn [db _]
    (vals (:responder-threads db))))

(reg-sub :requester-threads-with-messages
  :<- [:requester-threads]
  :<- [:threads]
  (fn [[requester-threads
        threads] _]
    (map
     (fn [{:keys [thread-id] :as itm}]
       (assoc itm :thread (get threads thread-id)))
     requester-threads)))

(reg-sub :responder-threads-with-messages
  :<- [:responder-threads]
  :<- [:threads]
  (fn [[responder-threads
        threads] _]
    (map
     (fn [{:keys [thread-id] :as itm}]
       (assoc itm :thread (get threads thread-id)))
     responder-threads)))

(reg-sub :unread-responder-messages
  (fn [[_query-v request-id]]
    [(rf/subscribe [:responder-thread request-id])
     (rf/subscribe [:threads])
     (rf/subscribe [:touches])])
  (fn [[thread-meta threads touches] _]
    (let [{:keys [thread-id]} thread-meta
          thread (get threads thread-id)
          last-touch (last-touch-access touches thread-id)]
      (unread-msgs-pred {:last-touch last-touch
                         :thread thread}))))

(reg-sub :all-unread-responder-messages
  :<- [:threads]
  :<- [:responder-threads]
  :<- [:touches]
  (fn [[msgs threads touches] _]
    (apply concat (map (fn [{:keys [_request-id  thread-id] :as msg}]
                         (let [thread (get msgs thread-id)
                               last-touch (last-touch-access touches thread-id)]
                           (unread-msgs-pred {:last-touch last-touch
                                              :thread thread}))) threads))))

(reg-sub :all-unread-requester-messages
  :<- [:requester-threads-with-messages]
  :<- [:touches]
  (fn [[msgs touches] _]
    ;; TODO
    []
    (apply concat (map (fn [{:keys [thread thread-id] :as msg}]
                         (let [last-touch (last-touch-access touches thread-id)]
                           (unread-msgs-pred {:last-touch last-touch
                                              :thread thread}))) msgs))))

(comment
  @(rf/subscribe [:requester-threads])
  (:requester-threads @re-frame.db/app-db)
  (:responder-threads @re-frame.db/app-db)
  @(rf/subscribe [:responder-threads-with-messages])
  @(rf/subscribe [:requester-threads-with-messages])
  @(rf/subscribe [:threads]))

(reg-sub :requester-thread
  :<- [:requester-threads-with-messages]
  (fn [table [_ request-id from-id]]
    (cond (and request-id from-id)
          (first (filter #(and
                           (= (:from-id %) from-id)
                           (= (:request-id %) request-id)) table))
          request-id
          (filter #(and
                    (= (:request-id %) request-id)) table))))

(comment
  @(rf/subscribe [:requester-thread 17592186051827])
  (rf/subscribe [:requester-thread ]))

(reg-sub :requester-threads
  (fn [db _]
    (vals (:requester-threads db))))

(rf/reg-sub-raw
 :unread-requester-parent-messages
 (fn [_ [_ request-id]]
   (reaction
     (let [thread-ids (map :thread-id @(rf/subscribe [:requester-thread request-id]))]
       (apply concat (map (fn [thread-id]
                            @(rf/subscribe [:unread-requester-messages thread-id]))
                          thread-ids))))))


(reg-sub :total-unread-msgs
  :<- [:all-unread-responder-messages]
  :<- [:all-unread-requester-messages]
  (fn [[m1 m2] _]
    (+ (count m2)
       (count m1))))

(reg-sub :user-unread-by-roles
  (fn [db _]
    (:user-unread-by-roles db)))

(reg-sub :threads
  (fn [db _]
    (:threads db)))

(reg-sub :thread
  (fn [db [_ thread-id]]
    (get-in db [:threads thread-id] [])))

(reg-sub :thread-messages
  (fn [db [_ thread-id]]
    (get-in db [:threads thread-id :messages] [])))

(reg-sub :typing-status
  (fn [db [_ thread-id from-id]]
    (get-in db [:typing-status thread-id from-id])))

(rf/reg-sub-raw :current-owner-active-requests-with-messages
 (fn [db _]
   (reaction
     (reduce
      (fn [acc {request-id :db/id :as itm}]
        (let [?msgs (vec (apply concat (map (comp :messages :thread) @(rf/subscribe [:requester-thread request-id]))))]
          (conj acc (-> itm
                        (cond-> ?msgs
                          (assoc :messages ?msgs))))))
      []
      @(rf/subscribe [:current-owner-active-requests])))))

(rf/reg-sub-raw :current-owner-history-requests-with-messages
 (fn [db _]
   (reaction
     (reduce
      (fn [acc {request-id :db/id :as itm}]
        (let [?msgs (vec (apply concat (map (comp :messages :thread) @(rf/subscribe [:requester-thread request-id]))))]
          (conj acc (-> itm
                        (cond-> ?msgs
                          (assoc :messages ?msgs))))))
      []
      @(rf/subscribe [:current-owner-history-requests])))))

(reg-sub :urgent
  (fn [db [_ thread-id]]
    (get-in db [:threads thread-id :messages] [])))

(comment


  @(rf/subscribe [:all-unread-responder-messages])
  @(rf/subscribe [:all-unread-requester-messages])
  (:requester-threads @re-frame.db/app-db)
  (:responder-threads @re-frame.db/app-db)
  (:dict @re-frame.db/app-db)
  (:last-seen @re-frame.db/app-db)
  (:threads @re-frame.db/app-db))
